import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { RadioGroup, RadioGroupItem, RadioGroupItemCard } from '@1trading/react/components/ui/radio-group';
import { Textarea } from '@1trading/react/components/ui/textarea';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { BINARY_ANSWERS } from '@/constants/answers';
import type { InstitutionAmlCtfSanctionsOrDefaults } from '@/features/institution/aml-ctf-sanctions/schema';

const InstitutionAmlCtfSanctionsFieldsetMonitoring = () => {
  const form = useFormContext<InstitutionAmlCtfSanctionsOrDefaults>();
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <FormField
        control={form.control}
        name="hasSuspiciousActivityPolicies"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.amlCtfSanctions.monitoring.hasSuspiciousActivityPolicies')}*</FormLabel>
            <FormControl>
              <RadioGroup
                defaultValue={field.value}
                variant="cards"
                aria-label={t('institutionDetails.amlCtfSanctions.monitoring.hasSuspiciousActivityPolicies')}
                onValueChange={field.onChange}
              >
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="transactionMonitoringMethods"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.amlCtfSanctions.monitoring.transactionMonitoringMethods')}*</FormLabel>
            <FormControl>
              <Textarea {...field} placeholder={t('institutionDetails.amlCtfSanctions.placeholders.transactionMonitoringMethods')} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="hasStrReportingObligation"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.amlCtfSanctions.monitoring.hasStrReportingObligation')}*</FormLabel>
            <FormControl>
              <RadioGroup
                defaultValue={field.value}
                variant="cards"
                aria-label={t('institutionDetails.amlCtfSanctions.monitoring.hasStrReportingObligation')}
                onValueChange={field.onChange}
              >
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="hasEmployeeEscalationProcess"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.amlCtfSanctions.monitoring.hasEmployeeEscalationProcess')}*</FormLabel>
            <FormControl>
              <RadioGroup
                defaultValue={field.value}
                variant="cards"
                aria-label={t('institutionDetails.amlCtfSanctions.monitoring.hasEmployeeEscalationProcess')}
                onValueChange={field.onChange}
              >
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
InstitutionAmlCtfSanctionsFieldsetMonitoring.displayName = 'InstitutionAmlCtfSanctionsFieldsetMonitoring';

export { InstitutionAmlCtfSanctionsFieldsetMonitoring };
